import { render } from "./InformesComponent.vue?vue&type=template&id=1aa33122&scoped=true"
import script from "./InformesComponent.vue?vue&type=script&lang=js"
export * from "./InformesComponent.vue?vue&type=script&lang=js"

import "./InformesComponent.vue?vue&type=style&index=0&id=1aa33122&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa33122"]])

export default __exports__